import React from "react"
import styles from "./section.module.scss"

export default ({children}) => (
    <section className={styles.section}>
    { children }
    </section>
)
